import React from 'react';
import { Breadcrumb, Layout, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import insertOficio from '../../../graphql/mutations/tramites/insertOficio.graphql';
import ProcesoImprimir from '../../procesos/ProcesoImprimir';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertOficio, {
    name: 'insertOficio',
  }),
  graphql(getUsuario)
)
class CrearOficio extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  generarDatos = () => {
    let datos = {
      usuario: this.props.data.getUsuario,
      organismo: this.props.data.getUsuario.organismo,
    };

    return datos;
  };

  guardarOficio = (htmlActuacion, idModeloNota, numero) => {
    console.log('Entro a guardar la actuacion...');
    console.log(numero);
    // console.log(htmlActuacion);

    this.setState({
      loading: true,
    });
    this.props
      .insertOficio({
        variables: {
          objOficio: {
            textoNota: htmlActuacion,
            idModeloNota: idModeloNota,
            numero: numero,
          },
        },
      })
      .then(res => {
        // console.log('LA RESPUESTA DE INSERTAR ACTUACION ES: ', res);

        if (res.data.insertOficio) {
          notification.success({
            message: 'Documento Creado correctamente',
            description:
              'El Documento se creó correctamente en la base de datos',
          });

          this.setState({
            loading: false,
          });
          // this.props.history.goBack();
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR DEL DOCUMENTO INDEPENDIENTE: ', err);

        notification.error({
          message: 'Error al agregar el Documento Independiente',
          description:
            'Se ha producido un error al agregar el documento independiente',
        });

        this.setState({
          loading: false,
        });
      });
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Documento Independiente</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nuevo Documento Independiente
          </h2>
          <br />
          <div style={estiloContent}>
            {step === 0 && (
              <ProcesoImprimir
                datos={this.generarDatos()}
                onImprimir={this.guardarOficio}
                onGuardar={this.guardarOficio}
                onCancel={this.onCancel}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearOficio);
